import { useSearchParams } from "react-router-dom";

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get("phoneNumber");

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, "+ ");
    }
    phoneNumber = textNumber;
  }

  return {
    carousel: searchParams.get("carousel") || "1",
    // "8789150732"
    user: searchParams.get("user") || "8789150732",
    duration: searchParams.get("duration") ? parseInt(searchParams.get("duration") || "") : 10000,
    period: searchParams.get("period") ? parseInt(searchParams.get("period") || "") : 600,
    repeatCount: parseInt(searchParams.get("repeatCount") || "") || 10,
    startFrom: parseInt(searchParams.get("startFrom") || "") || 1,
    bg: searchParams.get("bg") || null,
    scrollSpeed: searchParams.get("scrollSpeed") ? Number(searchParams.get("scrollSpeed")) : 3000,
    scrollDelay: searchParams.get("scrollDelay") ? Number(searchParams.get("scrollDelay")) : 2000,
    title: searchParams.get("title"),
    socials: searchParams.get("socials"),
    qrCode: searchParams.get("qrCode"),
    topOffset: searchParams.get("topOffset") || 10,
    phoneNumber,
  };
};
